/**
 * src/domains/applications/applications.api.ts
 *
 * All API calls for job applications.
 */
import { apiClient } from '../../infra/api/apiClient';

import type { Application, CreateApplicationPayload } from './applications.types';

export async function applyToJob(
  jobId: string,
  data: CreateApplicationPayload,
): Promise<Application> {
  return apiClient.post<Application>(`/marketplace/jobs/${jobId}/apply`, data);
}

export async function fetchApplicationsForJob(jobId: string): Promise<Application[]> {
  return apiClient.get<Application[]>(`/marketplace/jobs/${jobId}/applications`);
}

export async function fetchMyApplications(): Promise<Application[]> {
  return apiClient.get<Application[]>('/marketplace/applications/mine');
}

export async function updateApplicationStatus(
  applicationId: string,
  status: 'accepted' | 'rejected',
): Promise<Application> {
  return apiClient.patch<Application>(
    `/marketplace/applications/${applicationId}/status`,
    { status },
  );
}
